/* eslint-disable no-underscore-dangle */
// Types for Model Reviewer/Preparer Dashboard using Fulfillment API

import { Fulfillment } from 'api/models/Fulfillment';
import { AttioSortDirection } from 'dashboard409a/common/constants/analyst-dashboard';

export interface Note {
  id: number;
  content: string;
  author_id: number;
  author_email: string;
  author_name: string;
  created_at: string;
  updated_at: string;
}

export interface FulfillmentWithCompanyName extends Fulfillment {
  company_name: string;
  company_id: number;
  company_slug: string;
  attio_valuation_id: string;
  attio_company_id?: string;
  note?: Note | null;
  measurement_date?: string;
  measurement_date_slug?: string;
}

export interface ModelWithValuationData extends FulfillmentWithCompanyName {
  engagement_type?: string;
  valuation_date?: string;
  valuation_lead?: string;
  valuation_lead_image_src?: string;
  is_loading_valuation_data?: boolean;
  notes?: string; // Keep for backward compatibility
}

// User roles for filtering
export enum UserRole {
  REVIEWER = 'Reviewer',
  PREPARER = 'Preparer',
}

// Helper function to get status string from enum
export const getModelStatusString = (status: Fulfillment.model_status): string => {
  const statusMap = {
    [Fulfillment.model_status._0]: 'Draft',
    [Fulfillment.model_status._1]: 'Review',
    [Fulfillment.model_status._2]: 'In-process ScalarUSA',
    [Fulfillment.model_status._3]: 'Final',
    [Fulfillment.model_status._4]: 'COMPLETE',
    [Fulfillment.model_status._5]: 'WAITING',
  };
  return statusMap[status] || 'Unknown';
};

// eslint-disable-next-line no-underscore-dangle
export const isCompletedStatus = (status: Fulfillment.model_status): boolean => status === Fulfillment.model_status._3;

export interface UseModelsWithValuationDataProps {
  filterType: 'current' | 'past' | 'unassigned';
  preparerUserIds?: number[];
  reviewerUserIds?: number[];
  orderBy?: string;
  order?: AttioSortDirection;
}

export interface UseModelsWithValuationDataReturn {
  rows: ModelWithValuationData[];
  totalCount: number;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  updateModelNote: (modelId: number, noteContent: string, noteId?: number) => void;
  updateModelStatus: (modelId: number, newStatus: number) => void;
  updateModelDueDate: (modelId: number, newDueDate: string) => void;
}
